export const BoldEntries = ["Net Variance", "Total"];

export const OtherComponents = [
  "Net Variance",
  "Product GMS",
  "Sales Discounts",
  "Quick Pay Discounts",
  "Vendor Allowances",
  "Discretionary Coop",
  "Display Ads",
  "Inbound Freight",
  "Vendor Returns",
  "Liquidation Revenue",
  "Liquidation Cost",
];

export const VendorComponents = [
  "Closing Fees",
  "Fulfillment Fees",
  "Other Revenue",
  "Seller Credits",
  "Shipping Revenue",
  "Subscription Revenue",
  "Shipping Cost",
  "Refunds Revenue",
  "Refunds Cost",
  "Free Replacement Cost",
  "Giftwrap Revenue",
  "Giftwrap Cost",
];

export const GrossComponents = [
  "Variable Fc Cost",
  "Variable Cs Cost",
  "Bad Debt",
  "Payment Fees",
  "Associate Fees",
  "Sponsored Link Fees",
  "Other Cost",
];

export const FLCPComponentsOrdering = [...OtherComponents, ...VendorComponents, ...GrossComponents];

export const formatNumber = (value) => {
  return isNaN(value) ? 'N/A' : value.toFixed(2);
};



// WEBPACK FOOTER //
// ./src/components/reports/flcp/flcp_utils.js